import type { CsViewType } from "@/service/course.service";

/** Resolve CS detail view type from URL (survives refresh) with location.state fallback. */
export function resolveCsViewType(
  searchParams: URLSearchParams,
  stateViewType?: CsViewType
): CsViewType {
  const fromUrl = searchParams.get("viewType");
  if (fromUrl === "class") return "class";
  if (fromUrl === "course") return "course";
  if (stateViewType === "class") return "class";
  return "course";
}

export function buildCsViewCoursePath(
  resourceId: string,
  viewType: CsViewType = "course"
): string {
  const base = `/course-management/view-course/${resourceId}`;
  return viewType === "class" ? `${base}?viewType=class` : base;
}
